export const VossCustomerStatus = {
    Active: "Active",
    Terminated: "Terminated",
    Blocked: "Blocked"
}

export const VossCustomerStatusTranslation = {
    [VossCustomerStatus.Active]: "internalinfocontainer.active",
    [VossCustomerStatus.Terminated]: "internalinfocontainer.terminated",
    [VossCustomerStatus.Blocked]: "internalinfocontainer.blocked",
}
export const VossCustomerStatusDropdown = [
    { id: [VossCustomerStatus.Active], name: VossCustomerStatus.Active },
    { id: [VossCustomerStatus.Terminated], name: VossCustomerStatus.Terminated },
    { id: [VossCustomerStatus.Blocked], name: VossCustomerStatus.Blocked },
]